export enum SystemRole {
    ADMIN = "ROLE_ADMIN",
    USER = "ROLE_USER",
}
